import styled from "styled-components";
import { motion } from "framer-motion";
import { theme } from "@theme";

export const Wrapper = styled.div`
  width: 700px;
  padding: 8px;
  border-radius: 8px;
  background: rgba(255, 251, 248, 1);
  
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    display: flex;
    flex-direction: column;
    padding: 0;
    width: 100vw;
    height: 100%;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;
  padding-left: 16px;
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 0;
  }
`

export const HeaderTitle = styled.div`
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    font-size: 18px;
    width: 100%;
    background: rgba(249, 242, 236, 1);
    align-self: flex-start;
    padding: 18px 16px;
    border-bottom: 1px solid rgba(228, 215, 205, 1);
  }
`

export const ChapterDatesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    flex-wrap: wrap;
    padding-left: 16px;

    div:nth-child(2) {
      flex-grow: 1;
    }
  }
`
export const ChapterTitle = styled.div`
  padding-right: 24px;
  padding-left: 16px;
  @media screen and (max-width: ${theme.breakpoints.sm}) {
    padding: 0 16px 0;
  }
`

export const Divider = styled.div`
  height: 1px;
  width: calc(100% - 32px);
  margin: 16px;
  background: rgba(228, 215, 205, 1);
`

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
  padding-right: 24px;
  padding-left: 16px;

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    border-top: 1px solid rgba(228, 215, 205, 1);
    padding: 16px 8px;
    background: rgba(249, 242, 236, 1);
  }
`

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: rgba(137, 121, 110, 1);
  margin-right: 8px;
`;

export const IconWrapper = styled(motion.div)`
  display: flex;
  align-items: center;
`;

export const RollbackButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  font-size: 14px;
  cursor: pointer;

  color: rgba(198, 166, 145, 1);
  background: none;
  border: none;
  
  &:hover {
    color: rgba(137, 121, 110, 1);
  }
`
